import React from 'react';

const experiences = [
  {
  role: 'Team Lead',
  company: 'Thence',
  period: 'Jul 2024 – Apr 2025',
  description: 'Led the complete engineering team at Thence, managing delivery for major enterprise clients. This is where I connected with and shipped production systems for FITTR, HDFC Ergo, and Dhani (Indiabulls) — leading cross-functional teams, modernizing legacy stacks, and building AI-powered features.',
  tags: ['Team Leadership', 'FastAPI', 'React', 'AWS', 'Headless CMS', 'Mobile', 'AI'],
  },
  {
  role: 'Tech Lead',
  company: 'Alfalgo Technologies (Nexera)',
  period: 'Nov 2023 – Jun 2024',
  description: 'Determined optimal tech stack for an algorithmic trading platform. Engineered a scalable backtester, reducing operational costs by 70%. Containerized all services, implemented serverless architecture, and mentored team members to foster a collaborative, high-performance environment.',
  tags: ['Python', 'FastAPI', 'Redis', 'MongoDB', 'PostgreSQL', 'Celery', 'S3', 'Grafana', 'Prometheus', 'Loki', 'Twilio', 'Docker', 'AWS CodePipeline', 'AWS CodeBuild', 'EKS', 'EC2', 'AWS App Runner', 'OpenAI'],
  },
  {
    role: 'Founding Backend Developer',
    company: 'Oraph Private Limited (Algotest)',
    period: 'Feb 2023 – Jul 2023',
    description: 'As the founding backend developer from inception, owned all backend tasks. Notably enhanced broadcasting of real-time stock prices using Redis and FastAPI, achieving a 500% increase in efficiency.',
    tags: ['Python', 'FastAPI', 'Jinja', 'Bootstrap', 'Google Cloud', 'MySQL', 'Twilio'],
  },
  {
    role: 'Data Engineer (Intern)',
    company: 'Amazon',
    period: 'Jan 2020 – Jul 2020',
    description: 'Worked as a Data Engineering intern.',
    tags: ['Python', 'AWS', 'Data Engineering'],
  },
  {
    role: 'Software Developer (Intern)',
    company: 'Zoho',
    period: 'Jan 2019 – Jul 2019',
    description: 'Worked as a Software Developer intern.',
    tags: ['Software Development'],
  },
];


export default function NewResume() {
  return (
    <section id="resume" className="section">
      <span className="section-label animate-in">04 / Resume</span>
      <h2 className="section-title animate-in animate-in-delay-1">
        Where I've
        <br />
        made an impact.
      </h2>
      <p className="section-subtitle animate-in animate-in-delay-2" style={{ marginBottom: '3rem' }}>
        A timeline of roles where I've built scalable systems and led engineering teams.
      </p>

      {/* Experience Timeline */}
      <div style={{ marginBottom: '4rem' }}>
        <span className="section-label animate-in animate-in-delay-2">Experience</span>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }} className="animate-in animate-in-delay-3">
          {experiences.map((exp, i) => (
            <div
              key={exp.company}
              className="glass-card"
              style={{
                padding: '1.75rem',
                borderLeft: '2px solid #00ff88',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderLeftColor = '#00ff88';
                e.currentTarget.style.boxShadow = '0 0 20px rgba(0, 255, 136, 0.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderLeftColor = '#00ff88';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '0.5rem' }}>
                <h3 style={{ fontSize: '1.15rem', fontWeight: 600, color: '#ffffff' }}>
                  {exp.role} <span style={{ fontWeight: 400, color: '#888' }}>@ {exp.company}</span>
                </h3>
                <span style={{ fontSize: '0.8rem', color: '#00ff88', fontWeight: 500, whiteSpace: 'nowrap' }}>
                  {exp.period}
                </span>
              </div>
              <p style={{ color: '#888', fontSize: '0.9rem', lineHeight: '1.7', marginBottom: '1rem' }}>
                {exp.description}
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                {exp.tags.map((tag) => (
                  <span key={tag} className="code-tag" style={{ fontSize: '0.7rem' }}>{tag}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>


      {/* Education */}
      {/* <div style={{ marginBottom: '3rem' }}>
        <span className="section-label animate-in animate-in-delay-4">Education</span>
        <div
          className="glass-card animate-in animate-in-delay-5"
          style={{ padding: '1.75rem', maxWidth: '500px' }}
        >
          <h3 style={{ fontSize: '1.15rem', fontWeight: 600, color: '#ffffff', marginBottom: '0.25rem' }}>
            B.E. Computer Science
          </h3>
          <p style={{ color: '#888', fontSize: '0.9rem', marginBottom: '0.25rem' }}>
            Sri Venkateswara College of Engineering
          </p>
          <span className="code-tag" style={{ fontSize: '0.7rem' }}>Grad. Oct 2020</span>
        </div>
      </div> */}

      {/* Contact */}
      <div>
        <span className="section-label animate-in animate-in-delay-5">Contact</span>
        <div
          className="glass-card animate-in animate-in-delay-5"
          style={{ padding: '1.5rem', maxWidth: '400px' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <span style={{ color: '#00ff88', fontSize: '0.85rem' }}>✉</span>
              <a href="mailto:bstudies28@gmail.com" style={{ color: '#ccc', fontSize: '0.9rem' }}>
                bstudies28@gmail.com
              </a>
            </div>
            {/* <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <span style={{ color: '#00ff88', fontSize: '0.85rem' }}>📞</span>
              
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}